import { useIsAuthenticated, useMsal } from '@azure/msal-react';
import React from 'react';
import { Box, Heading, Text } from '@chakra-ui/react';

function HomePg({ setTabIndex }: { setTabIndex: any }) {
  const isAuthenticated = useIsAuthenticated();
  const { accounts } = useMsal();

  const getGreeting = (hours: number, firstName: any | undefined): string => {
    let greet;
    if (hours < 12) {
      greet = 'Morning';
    } else if (hours >= 12 && hours <= 17) {
      greet = 'Afternoon';
    } else if (hours >= 17 && hours <= 24) {
      greet = 'Evening';
    }

    return `Good ${greet}  ` + firstName;
  };

  const greeting = getGreeting(new Date().getHours(), '');

  return (
    <>
      <Box onClick={() => setTabIndex(0)}>
        {!isAuthenticated && (
          <>
            <Box p={4}>
              <Heading>Welcome</Heading>
              <Text>
                Please sign in using the sign in button at top right corner.
              </Text>
            </Box>
          </>
        )}
        {isAuthenticated && (
          <>
            <Box p={4}>
              <Heading>{greeting + '  ' + accounts[0].name} </Heading>
              <Text>Welcome to the Appeals Platform.</Text>
            </Box>
          </>
        )}
      </Box>
    </>
  );
}

export default HomePg;
